import { store } from "./state/store.js";
const ROUTES = [
    "home",
    "quickcal",
    "play",
    "designer",
    "visualizer",
    "diagnostics",
];
export function initRouter() {
    const apply = () => {
        const hash = location.hash
            .replace(/^#\/?/, "")
            .replace(/\/+$/, "")
            .trim();
        store.route.set(ROUTES.includes(hash) ? hash : "home");
    };
    window.addEventListener("hashchange", apply);
    apply();
}
export function navigate(route) {
    location.hash = `#/${route}`;
}
export function onRoute(fn) {
    return store.route.subscribe(fn);
}
